import { useReportPerform } from 'app/dataProviders/reports/hooks'
import { FinanceReportType } from 'app/dataTypes/reports/finances'
import { useCallback, useEffect } from 'react'
import { ReportSection, ResetLink } from 'app/common/templates-next/report-template'
import ReportFilterForm from 'app/common/templates-next/report-template/report-filter-form'
import ReportFilterLayout from 'app/common/templates-next/report-template/report-filter-layout'
import { ID } from 'app/common/ui-next/_filter-compilations/predefined-ids'
import { DetailsBox } from 'app/common/ui-next/_filter-compilations/details'
import styles from './Filters.module.scss'
import { filterInit, resetToDefaultAll } from './filter-init'
import { DateFilter, EncashmentsStatusFilter, OrgTypesFilter, OrgsFilter } from './filterItems'

type Props = {
  onReportId: (reportID: string | null) => void
}

export const Filters = ({ onReportId }: Props) => {
  const { perform } = useReportPerform({
    onReportId,
  })

  const resetAll = () => {
    resetToDefaultAll()
  }

  const performWithAdditionalData = useCallback(
    async (formData: FormData) => {
      await perform({ formData, reportType: FinanceReportType.Encashments })
    },
    [perform],
  )

  useEffect(() => {
    return filterInit()
  }, [])

  return (
    <ReportSection
      header="Фильтры"
      headerBar={<ResetLink onClick={resetAll}>{'Сбросить все фильтры'}</ResetLink>}
      resetStickyShift={false}
      skipPadding
    >
      <div className={styles.formContent}>
        <ReportFilterForm onSubmit={performWithAdditionalData} submitButtonTitle="Сформировать">
          {(pending) => (
            <ReportFilterLayout
              column1={
                <>
                  <OrgTypesFilter id={ID.orgType} pending={pending} />
                  <OrgsFilter id={ID.org} pending={pending} />
                  <DetailsBox id={ID.details} defaultSelection disabled />
                </>
              }
              column2={
                <>
                  <DateFilter id={ID.date} pending={pending} />
                  <EncashmentsStatusFilter id={ID.encashmentsStatus} pending={pending} />
                </>
              }
            />
          )}
        </ReportFilterForm>
      </div>
    </ReportSection>
  )
}
